export default __webpack_public_path__ + "static/media/avatar-admin.d74bdf9d.png";